<template>
    <div class="mb-28px">
        <v-row no-gutters class="delivery-tab row-cols-md-5 my-n4px">
            <v-col class="my-4px">
                <v-btn x-large block :color="`${_category ? 'transparent' : 'primary'}`" @click="setQuery(null)">
                    <span class="mr-4px mr-md-6px">
                        <v-img :src="`${_category ? '/images/giftcard/all_b.png' : '/images/giftcard/all_w.png'}`" alt="all" :aspect-ratio="25 / 26" width="26" height="25" contain />
                    </span>
                    <span class="font-size-14 font-size-lg-18">전체</span>
                </v-btn>
            </v-col>
            <v-col v-for="category in categories" :key="category._id" class="my-4px">
                <v-btn x-large block :color="`${firstCategory?._id === category._id ? 'primary' : 'transparent'}`" @click="setQuery(category._id)">
                    <span class="mr-4px mr-lg-6px">
                        <v-img :src="firstCategory?._id !== category._id ? setImgSrc(category?.icon) : setImgSrc(category?.icon2)" :aspect-ratio="25 / 26" width="26" height="25" contain />
                    </span>
                    <span class="font-size-14 font-size-lg-18">
                        {{ category?.name }}
                    </span>
                </v-btn>
            </v-col>
        </v-row>
        <template v-if="secondCategories?.length">
            <div class="delivery-tabs-2">
                <!-- <v-row class="ma-n1">
                    <template v-for="(category, index) in secondCategories">
                        <v-col :key="index" cols="auto" class="pa-1">
                            <v-chip class="rounded-pill px-3 py-5" large :class="{ 'v-chip--active': _category === category?._id }" @click="setQuery(category._id)">
                                <v-img :src="_category === category?._id ? setImgSrc(category?.icon2) : setImgSrc(category?.icon)" :aspect-ratio="25 / 26" contain large />
                                <span class="font-size-12 font-size-lg-14">
                                    {{ category?.name }}
                                </span>
                            </v-chip>
                        </v-col>
                    </template>
                </v-row> -->
                <v-tabs hide-slider show-arrows class="mx-n1">
                    <template v-for="(category, index) in secondCategories">
                        <v-tab :key="index" class="px-1">
                            <v-chip class="rounded-pill px-3 py-5" large :class="{ 'v-chip--active': _category === category?._id }" @click="setQuery(category._id)">
                                <v-img :src="_category === category?._id ? setImgSrc(category?.icon2) : setImgSrc(category?.icon)" :aspect-ratio="25 / 26" contain large />
                                <span class="font-size-12 font-size-lg-14">
                                    {{ category?.name }}
                                </span>
                            </v-chip>
                        </v-tab>
                    </template>
                </v-tabs>
                <!-- <v-tabs v-model="tab" hide-slider show-arrows>
                    <template v-for="(category, index) in secondCategories">
                        <v-tab :key="index" @click="setQuery(category._id)" :value="index + 1">
                            <v-chip outlined>
                                <span class="mr-4px mr-md-6px">
                                    <v-img :src="_category === category?._id ? setImgSrc(category?.icon2) : setImgSrc(category?.icon)" :aspect-ratio="25 / 26" width="26" height="25" contain />
                                </span>
                                <span class="font-size-14 font-size-lg-18">
                                    {{ category?.name }}
                                </span>
                            </v-chip>
                        </v-tab>
                    </template>
                </v-tabs> -->
            </div>
        </template>
    </div>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            categories: [],
            fullCategories: [],
            // tab: 0,
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            await this.search();
        },
        async search() {
            try {
                let { categories } = await api.v1.dshop.categories.gets({ headers: { limit: 0 } });

                this.categories = categories.filter(({ depth }) => depth === 1);
                this.fullCategories = categories;

                // this.tab = (this.secondCategories || []).findIndex((category) => category?._id === this._category) + 1;
            } catch (error) {
                console.error(error);
                alert(error?.message);
            }
        },
        setQuery(_category) {
            let { ...query } = this.$route.query;
            query._category = _category;

            delete query.page;

            if (!query?.sort) delete query.sort;
            if (!query?._category) delete query._category;
            if (!query?.searchValue) {
                delete query.searchValue;
                delete query.searchKey;
            }

            // this.tab = 0;

            this.page = 1;
            this.$router.push({ query });
        },
        setImgSrc(src) {
            // return `http://localhost:8081${src}`;
            // return `https://dev-giftcard.uxi.kr/${src}`;
            return `https://daehanbooksgiftcard.com/${src}`;
        },
    },
    computed: {
        _category() {
            return this.$route.query._category;
        },
        firstCategory() {
            if (!this._category) return null;

            const curCategory = this.fullCategories.find(({ _id }) => _id === this._category);

            if (curCategory?.depth === 1) return curCategory;

            return this.categories.find(({ _id }) => _id === curCategory?._parents[0]);
        },
        secondCategories() {
            if (!this._category) return null;

            return this.firstCategory?.children || [];
            // return Array.from({ length: 50 }, (v, i) => i++);
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep .v-btn.v-size--default {
    height: 56px;
}
::v-deep .v-btn.transparent {
    color: #595656 !important;
}

.row.delivery-tab {
    > [class*="col"] {
        border: 1px solid var(--border-color);
    }
}
.delivery-tabs-2 {
    margin-top: 20px;
    .v-chip {
        border: 1px solid;
        .v-image {
            width: 14px;
            margin-right: 4px;
        }
        &--active {
            background-color: var(--v-primary-base);
            border-color: var(--v-primary-base);
            ::v-deep {
                .v-chip__content {
                    color: #fff;
                }
            }
        }
        &:not(.v-chip--active) {
            background-color: #fff;
            border-color: var(--border-color);
            ::v-deep {
                .v-chip__content {
                    color: #595656;
                }
            }
        }
    }
    .v-tabs {
        .v-tab {
            min-width: initial;
        }
        ::v-deep {
            .v-slide-group__prev,
            .v-slide-group__next {
                margin: initial;
            }
            .v-slide-group__prev .v-icon,
            .v-slide-group__next .v-icon {
                display: block;
            }
        }
    }
}

@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .row.delivery-tab {
        > [class*="col"] {
            &:not(:last-child) {
                border-right: 0;
            }
        }
    }
}
@media (min-width: 1024px) {
    ::v-deep .v-btn.v-size--default {
        height: 80px;
    }
}
@media (min-width: 1200px) {
}
</style>
